import styled from 'styled-components';

const RootContainer = styled.div`
  position: fixed;
  z-index: var(--z-toolbox-subnav) !important;
  background-color: var(--dark);
  overflow: hidden;
  color: white;
  display: flex;
  h6 {
    color: var(--white);
    font-weight: var(--font-weight-500);
    letter-spacing: 0em;
    margin: 0;
    padding: 0;
    font-size: var(--font-size-h5);
    line-height: var(--line-height-130);
    @media (max-width: 1199px) {
      font-size: var(--font-size-16);
      line-height: 28px;
    }
  }
`;

export const MobileSubNavContainer = styled(RootContainer)`
  @media (max-width: 1199px) {
    bottom: 50vh;
    left: 0;
    width: 40px;
    height: 60x;
    background-color: var(--dark);
    border-radius: 0;
    padding: 13px 12px 17px 9px;
    filter: drop-shadow(0px 15px 40px rgba(11, 26, 33, 0.1));
    z-index: var(--z-toolbox-subnav-mobile) !important;
    display: flex;
    align-items: center;
    border-radius: 0 7px 7px 0;
    box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.2);

    svg {
      margin-left: -2px;
    }

    &.open {
      display: none;
    }
  }

  @media (min-width: 1200px) {
    display: none;
  }
`;

export const SubNavContainer = styled(RootContainer)`
  display: flex;
  position: fixed;
  top: ${({ bannerHeight }) => (bannerHeight ? `${bannerHeight}px` : 0)};
  left: 0;
  padding: 37px 14px 0 16px;
  flex-direction: column;
  justify-content: space-between;
  width: 80px;
  height: 100vh;
  transition: width 300ms ease;
  @media (max-width: 1199px) {
    display: none;
    flex-direction: column-reverse;
    padding-top: 0px;
    justify-content: flex-end;
    background: #323232f2;
  }
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  &.open {
    display: flex;
  }
  &:hover,
  &.open {
    left: 0;
    width: 245px;
    @media (max-width: 1199px) {
      width: 100vw;
    }
    cursor: pointer;
    .mobile-nav {
      display: none;
    }
    .nav-user-row {
      flex-direction: row;
      align-items: flex-end;
      margin-bottom: 0;
      > div {
        width: 50%;

        &:first-child {
          margin-right: 14px;
        }
        > div,
        > a > div {
          width: 100%;
        }
      }
    }
    div.selected {
      background-color: var(--white);
      border-radius: 4px;
      h6 {
        color: var(--darkest);
      }
      svg path {
        fill: var(--darkest);
      }
    }
  }
  hr {
    width: 100%;
    height: 2px;
    color: var(--white);
  }
`;

export const IconContainer = styled.div`
  width: 50px;
  height: 50px;
  svg {
    width: 24px;
    height: 24px;
  }
  text-align: center;
  padding: 13px;
`;

export const UserIconContainer = styled(IconContainer)`
  border: 1px solid var(--white);
  box-sizing: border-box;
  border-radius: 4px;


  &.popoverOpen {
    background: var(--white);
  }

  @media (hover: hover) {
    &:hover {
      background-color: var(--white);
    ]
  }
`;

export const NavRow = styled.div`
  width: 210px;
  clear: left;
  float: left;
  &:hover,
  &.selected a > div:first-child,
  &.selected a > div > div {
    background-color: var(--white);
    border-radius: 4px;
    h6 {
      color: var(--darkest);
    }
    svg path {
      fill: var(--darkest);
    }
  }
  margin-bottom: 13px;
  @media (max-height: 568px) {
    margin-bottom: 2px;
  }
`;

export const NavCol = styled.div`
  float: left;
`;

export const NavSeparator = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  width: 100%;
  padding-bottom: 20px;
  height: 0px;
  clear: left;
  @media (max-height: 640px) {
    padding-bottom: 0px;
  }
  @media (max-height: 375px) {
    display: none;
  }
`;

export const NavTitleCol = styled(NavCol)`
  padding: 12px 13px 8px 14px;
`;

export const NavRowUser = styled(NavRow)`
  @media (max-width: 1199px) {
    top: 15px;
    height: 50px;
    width: calc(100vw - 30px);
    margin-bottom: 20px;
  }
  &.nav-signin-row {
    @media (max-width: 1199px) {
      height: auto;
      margin-top: 10px;
      border: 1px solid var(--white);
      box-sizing: border-box;
      border-radius: 4px;
      div {
        border: 0;
      }
      a {
        display: flex;
        justify-content: center;
      }
    }
    @media (max-height: 375px) {
      margin-bottom: 0px;
    }
  }
  &.nav-user-row {
    height: 120px;
    margin: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    div.selected {
      background-color: var(--white);
      svg path {
        fill: var(--darkest);
      }
    }
    > div > a > div,
    > div > div {
      margin-bottom: 10px;
      width: 50px;
      @media (max-width: 1199px) {
        width: 100%;
      }
      padding: 10px;
      &:hover {
        svg path {
          fill: var(--darkest);
        }
      }
    }
    &:hover {
      background-color: transparent;
      svg path {
        fill: var(--white);
      }
    }

    @media (max-width: 1199px) {
      height: auto;
      margin-top: 10px;
      flex-direction: row-reverse;
      width: calc(100vw - 30px);
    }
  }
`;
export const IconCluster = styled.div`
  @media (min-width: 1200px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  @media (min-height: 736px) {
    margin-top: 30px;
  }
`;
export const BurgerContainer = styled(IconContainer)`
  border-radius: 4px;
  &.open {
    background-color: var(--white);
    svg path {
      stroke: var(--darkest);
    }
  }
  @media (max-width: 1199px) {
    display: none;
  }
`;
